import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async getAll() {
        return http.get(buildUrlFromLocation("/components_all_status"));
    }
};



// WEBPACK FOOTER //
// ./src/services/status.js